<template>
  <div class="padded">

<!--
    <el-row type="flex">
      <el-col :span="24" align="center">

      <request-action
       ref="rtx"
       v-if="rowData && rowData.actionType && rowData.actionType.startsWith('RT')"
       :site-id="siteId ? siteId : rowData.site_id"
       :org-id="rowData.organisation_id"
       :type="rowData.actionType"
       :adding="false"
       :row-data="rowData">
    </request-action>

    <ticket-action
      ref="tic"
      v-if="rowData.actionType==='COMPLAINT'"
      :showText="true"
      :row-data="rowData"
      size="small"
     :site-id="siteId"
     :org-id="rowData.organisation_id"
     :ticket-id="rowData.ticket_id" />

    <permit-workflow-action
      :ref="permitLabel"
      v-if="rowData.actionType===permitLabel"
      :showText="true"
      :row-data="rowData"
      size="small"
      :site-id="siteId"
      :org-id="rowData.organisation_id" />

    </el-col>
  </el-row>
-->
    <el-col align="left">

    <edit-pane
      v-if="!hidePanel"
      ref="ep"
      prefix="Action: "
      :title="form.summary"
      :is-edit="this.editMode"
      @save="onSave"
      @cancel="onCancel"
      @edit="onEdit"
      @add="onSave" />

    <el-form ref="actionDetailsForm" :model="form" label-width="120px">

      <el-row :gutter="12">
        <el-col :sm="24" :md="mdreq" :lg="lgreq">
        <div v-if="this.isTowerCo() && !type">
            <select-action-type v-model="form.actionType" :disabled="disabled" @change="check" />
            &nbsp;
        </div>

          <div v-else>
            <el-form-item label="Action Type">
              <b>{{this.form.actionType}}</b>
            </el-form-item>
          </div>
        </el-col>


          <section v-if="isRequest">

            <el-col :sm="24" :md="mdreq" :lg="lgreq">

              <select-sharer v-if="isTowerCo()"
                label=""
                :placeholder="isBackhaul ? 'Backhaul Customer' : 'Sharer'"
                v-model="form.organisation_id"
                :limit="form.actionType != 'RTS' ? (limits && limits.length === 0 ? null : limits) : null"
                :disabled="disabled" @change="check" />

            </el-col>

            <el-col v-if="isBackhaul && (isTowerCo() || isTelco())" :sm="24" :md="mdreq" :lg="lgreq">

              <switch-input
                  v-model="isProvider"
                  on-text="Provider"
                  off-text="Customer"
                  :disabled="disabled" />

            </el-col>

            <el-col v-if="isBackhaul" :sm="24" :md="mdreq" :lg="lgreq">

              <select-backhaul-provider
                  v-if="isBackhaul && (isProvider || isBackhaulCo())"
                  label="Provider"
                  v-model="form.provider_id"
                  placeholder="Select Backhaul Provider"
                  :disabled="disabled || isBackhaulCo()"
                  @change="check" />

                <select-backhaul-type
                 v-if="(isBackhaul && isProvider) || isBackhaulCo()"
                 v-model="form.backhaulType" />
            </el-col>

            <!--
              XOL-440/442: a Backhaul-org user IS the provider, so this filter is
              meaningful to them — but the el-col was gated on `isProvider`, which
              only the Customer/Provider toggle sets and that toggle is
              TowerCo/Telco-only. Every sibling provider control already carries
              the `|| isBackhaulCo()` arm; this one was missed, so the filter was
              invisible to the one persona it matters most to while `isExcl`
              defaulted true — an always-on narrowing with no way to switch it off.
              That is what stopped TM/TIME reaching sharer sites they do not yet
              backhaul, which is the whole point of XOL-440.
            -->
            <el-col v-if="isBackhaul && (isProvider || isBackhaulCo())" :sm="24" :md="mdreq" :lg="lgreq">

              <check-box
                  v-model="isExcl"
                  :disabled="disabled">
                  {{ isBackhaulCo() ? 'Only show my backhaul sites' : 'Show only sites by provider' }}
              </check-box>

            </el-col>

            <el-col :sm="24" :md="mdreq" :lg="lgreq">
              <select-sharer v-if="isBackhaulCo()"
                v-model="form.organisation_id"
                :disabled="disabled" @change="check" />
            </el-col>
        </section>

      </el-row>

      <!--
        XOL-440: the site search is ALWAYS scoped to the sharer — the telco
        CUSTOMER the request is raised for — and the provider only ever narrows
        that set. Five modes reach this component:

          Backhaul caller    sharer = the Telco picked in "Sharer"
          Telco   (Customer) sharer = own org, no provider
          Telco   (Provider) sharer = own org, provider = picked provider
          TowerCo (Customer) sharer = the Telco picked in "Backhaul Customer"
          TowerCo (Provider) both

        `:sharer` previously hard-coded null for a Backhaul caller, discarding
        the Sharer the user had just picked, so the URL degraded to
        `/sites/backhaul/sharer/null/<provider>` and the API rejected the
        literal "null" in an integer segment with a 400 — surfaced to the user
        as "Search failed - check your connection".

        `:provider` is gated on whichever personas actually get the filter
        checkbox, so `isExcl` is respected rather than forced on or off. For a
        Backhaul caller it defaults OFF (see created()): the base set is the
        sharer's sites, and "Only show my backhaul sites" narrows it on request.
        Defaulting it on would show only the sites that provider already
        backhauls — exactly the restriction XOL-440 exists to remove.

        `:disabled` no longer force-enables for Backhaul: the select stays shut
        until a Sharer exists, which is what keeps the null out of the URL.
      -->
      <select-site
        ref="selectSite"
        v-if="showSiteSelect"
        v-model="form.site_id"
        :show-warning="true"
        :allow-scope-selection="true"
        :sharer="isTelco() ? org().id : form.organisation_id"
        :provider="(isBackhaul && (isProvider || isBackhaulCo()) && isExcl) ? form.provider_id : null"
        :backhaul-search="(form.actionType === 'RTB')"
        :action-type="form.actionType.startsWith('RT') ? form.actionType : null"
        :exclude-sharer="(form.actionType === 'RTS')"
        :callback="successSite"
        :disabled="!(isProvider ? form.provider_id && form.organisation_id : form.organisation_id)"
        @change="check" />

      <el-row style="padding-top: 1em;">
        <el-col v-if="isTowerCo()" :sm="24" :md="12" :lg="8">
          <date-input label="Actual Date" v-model="form.actualDate" :disabled="disabled" />
        </el-col>

        <el-col :sm="24" :md="12" :lg="isTelco() ? 12 : 8">
          <date-input label="Target Date" v-model="form.targetDate" :disabled="disabled" />
        </el-col>

        <el-col :sm="24" :md="12" :lg="isTelco() ? 12 : 8">
          <select-priority v-model="form.priority" :disabled="disabled" @change="check" />
        </el-col>

      </el-row>

      <text-input v-if="isTowerCo()" label="Summary" prop="summary" v-model="form.summary" :disabled="disabled" placeholder="Summary of action" style="padding-top: 0.5em;" />

      <el-form-item v-if="isTowerCo()" prop="remarks" label="Remarks">
        <el-input type="textarea" :rows="3" v-model="form.remarks" :disabled="disabled" />
      </el-form-item>

    </el-form>

    <el-col v-if="form && form.updated_at" align="right" :span="24">
      <span class="pull-right">Last update: <b>{{formatFriendlyDate(form.updated_at)}}</b> ({{formatDateTime(form.updated_at)}})<span v-if="form.updated_by"> by {{form.updated_by}}</span></span>
    </el-col>

  </el-col>
</div>

</template>


<script>


import {DATETIME_SQL_FORMAT, ENABLE_SAVE_EVENT, DISABLE_SAVE_EVENT, settings} from '@/components/Data'

import SiteMixins from '@/mixins/SiteMixins'

import RequestAction from '@/components/actions/RequestAction'
import ProgressWorkflowAction from '@/components/actions/ProgressWorkflowAction'

import RenewalAction from '@/components/actions/RenewalAction'
import TicketAction from '@/components/actions/TicketAction'


import AcquireRequest from '@/components/requests/acquire/AcquireRequest'

import SelectActionType from '@/components/atoms/selects/SelectActionType'

import SelectBackhaulType from '@/components/atoms/selects/SelectBackhaulType'
import SelectBackhaulProvider from '@/components/atoms/selects/SelectBackhaulProvider'

import SelectPriority from '@/components/atoms/selects/SelectPriority'

import SelectSharer from '@/components/atoms/selects/SelectSharer'

export default {

  components: {
    AcquireRequest,
    SelectActionType,
    SelectBackhaulType,
    SelectBackhaulProvider,
    SelectPriority,
    SelectSharer,
    RenewalAction,
    RequestAction,
    ProgressWorkflowAction,
    TicketAction
  },

  mixins: [SiteMixins],

  props: {
    rowData: {
      type: Object,
      default: null
    },
    siteId: {
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    },
    tableRef: {
      type: String,
      default: 'action-table'
    },
    adding: {
      type: Boolean,
      default: false
    },
    hidePanel: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    isProvider: function (data) {
      this.siteData = null
    }
  },



  methods: {

    getSharerIds (sharerIds) {
      this.limits = sharerIds
    },


    /**
     XOL-445: the field state a brand-new request starts from.
     *
     * created() applied these once at mount and resetData() restored only five
     * of them, so after a save the dialog kept the previous provider, backhaul
     * type, priority, dates, remarks and Customer/Provider toggle. Both entry
     * points now share this, so "fresh form" means the same thing on mount and
     * after a save.
     *
     * organisation_id and provider_id are persona-derived rather than blanked:
     * a Telco IS its own sharer and a Backhaul org IS its own provider. The old
     * resetData() nulled organisation_id, and since the Sharer control only
     * renders for Tower Co and Backhaul, a Telco had nothing to put it back —
     * check() then kept Save disabled, so a second request could not be
     * submitted from the same mounted form.
     */
    applyCreateDefaults () {
      this.form.actionType = this.type ? this.type : null
      this.form.backhaulType = (this.form.actionType === 'RTB' ? 'Fibre' : null)
      this.form.summary = null
      this.form.remarks = null
      this.form.priority = 'Medium'
      this.form.actualDate = new Date()
      this.form.targetDate = new Date(Date.now() + 12096e5) // 14 days
      this.form.site_id = this.siteId

      this.form.organisation_id = this.isTelco() ? this.org().id : (this.sharer ? this.sharer : null)
      this.form.provider_id = this.isBackhaulCo() ? this.org().id : null

      this.isProvider = false
      this.isExcl = !this.isBackhaulCo()   // XOL-442: off for Backhaul, on otherwise
    },


    resetData () {
      this.applyCreateDefaults()
      this.clearSiteInfo()

      // resetData() never re-evaluated the Save gate, so the button kept
      // whatever state it held before the form was emptied.
      this.check()
    },


    success (response) {

      // XOL-444: the follow-up POST /backhaul that used to live here is gone.
      //
      // ActionsController@store already creates the backhaul row for an RTB and
      // links it to the action, so this second call only ever duplicated it —
      // and duplicated it BADLY, because the payload carried no action_id. On
      // Tower Company, where the write is permitted, that silently produced
      // orphaned rows (e.g. backhaul 956: site 495, provider 804, action_id
      // NULL, alongside a properly linked twin). On Telco it simply 403'd:
      // POST /api/backhaul (add) is granted to Tower Company only, so the user
      // saw "You do not have permission to save Backhaul Provider [route_acl]"
      // immediately after the request itself had saved successfully.
      //
      // The conditions could not diverge: this fired when the action was an RTB
      // with a provider set, which is exactly store()'s own condition, and if
      // store() rejects a duplicate it rolls back and success() never runs. The
      // same block is already commented out in ActionDetailsNew.vue.

      this.$events.emit(this.tableRef + '-refresh-table')

      if (this.isAdding) {
        this.resetData()
      }

      this.$emit('update-stats')
    },


    successSite (siteId, siteName, data) {

      if (data) {
        delete data.stats
        delete data.landowner
//        delete data.backhaul
//        delete data.sharers
      }

      this.siteName = siteName
      this.siteData = data
      this.form.site_id = siteId
/*
      @BUG OK for first site selected, not updated second,third sites, etc.

      if (!this.form.summary) {
        this.form.summary = this.form.actionType + ': for ' + this.siteName
      }
*/
      this.check()
    },


    clearSiteInfo () {
      this.siteName = null
      this.form.site_id = null
      this.form.summary = null
      this.siteData = null
    },


    onCancel () {
      this.disabled = true
      this.resetData()
    },


    onEdit () {
      this.disabled = false
    },


    onAdd () {
      this.disabled = false
      this.onSave()
    },


    onSave () {

      if (!this.form.summary || this.form.summary === '') {
        if (this.form.actionType) {
          this.form.summary = this.form.actionType
        }


        if (this.site && this.site.siteName) {

          this.form.summary = this.form.actionType + ' for ' + this.site.siteName

        } else {

          if (this.form.organisation_id && this.$refs.selectOrg) {
            this.form.summary = this.form.summary + ' for ' + this.$refs.selectOrg.selected.currentLabel
          }

        }

      }


      if (this.isBackhaul) {
        this.form.subActionType = (this.isProvider ? 'PROV' : 'CUST')
      }


      if (!this.form.actualDate) {
        this.form.actualDate = new Date()
      }

      if (!this.form.targetDate) {
        this.form.targetDate = this.addDateTime(new Date(), 14, 'day', DATETIME_SQL_FORMAT)
      }


      this.form.status = (this.isTelco() || this.isBackhaulCo()) ? 'NEW' : (this.form.status ? this.form.status : 'Pending')

      if (!this.form.organisation_id && this.isTelco()) {
        this.form.organisation_id = this.org().id
      }

      this.form.targetDate = this.formatDateSql(this.form.targetDate)
      this.form.actualDate = this.formatDateSql(this.form.actualDate)

      this.saveForm(this, '/actions', this.form.id, this.form, this.form.summary, this.success)

      if (this.adding) {
        this.disabled = false
      } else {
        this.disabled = true
      }

      //      this.resetData()
    },


    onClose () {
      this.resetData()
    },


    check (data) {
      if (this.form.actionType) {
        if (this.form.actionType.startsWith('RT')) {

          if (this.form.organisation_id && this.form.site_id) {
            return this.$events.emit(ENABLE_SAVE_EVENT)
          }

        } else {

          if (this.form.site_id) {
            return this.$events.emit(ENABLE_SAVE_EVENT)
          }

        }
      }

      this.$events.emit(DISABLE_SAVE_EVENT)
    }

  },

  computed: {
    isRequest: function () {
      return this.form.actionType && this.form.actionType.startsWith('RT')
    },

    isAcquire: function () {
      return this.form.actionType && this.form.actionType.startsWith('RTA')
    },

    isBackhaul: function () {
      return this.form.actionType && this.form.actionType.startsWith('RTB')
    },

    mdreq: function () {
      return this.isBackhaul ? 8 : 12
    },

    lgreq: function () {
      return this.isBackhaul ? 8 : 12
    }

  },


  data () {
    return {
      disabled: true,
      permitLabel: settings.permitLabel,
      isAdding: this.adding,
      isProvider: false,
      isExcl: true, // was false.
      siteName: null,
      siteData: null,
      showSiteSelect: !this.siteId,
      form: this.adding ? this.getTableStruct('actions') : this.rowData,
      limits: null
    }
  },


  created () {

    // XOL-440/442: "Only show my backhaul sites" defaults OFF for a Backhaul
    // org user. The parent ticket asks that a backhaul provider be able to list
    // the SHARER's sites, not just its own, so narrowing to its own is opt-in.
    // Defaulting on would show only the sites it already backhauls and
    // reproduce the very complaint the ticket was raised about. The `true`
    // default in data() is retained for the Tower Co / Telco provider modes,
    // where the equivalent checkbox has always started ticked.
    if (this.isBackhaulCo()) {
      this.isExcl = false
    }

    if (this.rowData && this.rowData.id) {
      this.fetchData('/sites/sharer-ids/' + this.rowData.id, this.getSharerIds)
    }

    if (this.adding) {

      this.disabled = false

      // XOL-445: shared with resetData() so a fresh form and a form reset after
      // a save cannot drift apart. Replaces the inline assignments plus the
      // `if (!this.form.actualDate)` / `if (!this.form.targetDate)` guards that
      // used to live here — those guarded against clobbering an existing value,
      // but this branch only runs when adding, where the struct is blank.
      this.applyCreateDefaults()

      delete this.form.id

    }


    if (!this.form.site_id && this.siteId) {
      this.form.site_id = this.siteId
    }


    if (!this.form.organisation_id) {
      this.form.organisation_id = this.isTelco() ? this.org().id : (this.sharer ? this.sharer : null)
    }

    if (!this.form.provider_id) {
      this.form.provider_id = this.isBackhaulCo() ? this.org().id : null
    }


    if (this.adding && !this.siteData && this.rowData && this.rowData.siteName) {
      this.siteData = this.rowData
    }

    if (this.form.site_id) {
      this.showSiteSelect = false
    }

    if (!this.siteId && this.isRequest && this.adding) {
      this.$events.emit(DISABLE_SAVE_EVENT)
    }

//    console.log('siteId', this.siteId, this.showSiteSelect)
//    console.log('siteId', this.siteId, 'form', this.form, 'rowData', this.rowData)
//  console.log('ActionDetails:', 'adding? ', this.adding, 'sharer:', this.sharer, this.form.organisation_id)

  }
}

</script>

<stype scoped>
  .el-select {display: inline-block; width: 100%;}
</style>
